// extracted by mini-css-extract-plugin
export var availableGamesContainer = "AvailableGames-module--availableGamesContainer--3qwPw";
export var gameButton = "AvailableGames-module--gameButton--20vDK";